import axios from 'axios'
// axios.defaults.baseURL = 'https://ccicnb-zjlm-dev.cnoolbest.com/ccicnb-main-provider1';
axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/json'; //'application/x-www-form-urlencoded'
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('authToken')
    if (token) {
        config.headers.Authorization = token
    }
    return config;
}, err => {
    console.log("请求拦截=>", err);
    return err;
})
axios.interceptors.response.use(res => {
    // console.log("响应拦截=>", res.data);
    return res ? res.data : res;
}, err => {
    console.log("响应拦截错误完整信息=>", err.response)
    if (err.status == 400) {
        err.response.data.message = '请求参数错误'
    } else if (err.status == 401) {
        err.response.data.message = '权限不足'
    }
    throw err.response.data;
})
export default axios
